import videoJsonConfig from "../../../../Settings/global/video.json";
import jwplayer from "../../../libs/jwplayer-7.6/jwplayer";

jwplayer.key = "rgP22Py/jYzmXcg4SWRmPOsIvMZfZ8yx/nnong==";
window.jwplayer = jwplayer;

export function render(nodo, video_id, multimediofileId, multimedioJWKey, multimediofileJWKey, videoDestacado, showAds, autoPlay, arrayTags, videoTag_Home, contenedor, titulo) {
    let nodoId = "jwVideo" + multimediofileId,
        playlistUrlBase = videoJsonConfig.playlistUrlBase,
        settings = videoJsonConfig.settings; //new LN.conf.video.settings();

    if (multimedioJWKey) {
        /* Es una playlist */
        settings.playlist = playlistUrlBase + multimedioJWKey + ".xml";
        //settings.skin = undefined;
    } else if (multimediofileJWKey) {
        /* Es un video */
        settings.playlist = playlistUrlBase + multimediofileJWKey + ".xml";
    }

    //TODO: SHARING FUNCTION (<iframe>)---------------------------------------------------------------------------------------------------
    //if (video_id != '' && settings.sharing.code ){ 
    //    settings.sharing.code = '<iframe src="' + document.location.origin + '/herramientas/modal-video/-multimedio_id=' + video_id + '" width="100%" height="650"/>'
    //}

    //if (settings.sharing.link && settings.sharing.link.indexOf('http://') != 0)
    //    settings.sharing.link = document.location.origin + settings.sharing.link;
    //-------------------------------------------------------------------------------------------------------------------------------------

    //TODO: VER EL TEMA DE LOS ADS EN LOS VIDEOS------------------------------------------------------------------------------------------
    if (showAds != undefined && showAds == 0)
    {
        settings.advertising = undefined;
    }
    else {
        var d = new Date();
        var timestamp = d.getTime();
        settings.advertising.schedule.myAds.tag = "https://pubads.g.doubleclick.net/gampad/ads?slotname=/133919216/lanacion/" + window.LN.tipoPaginaBanner + "/preroll&sz=640x480|400x300&ciu_szs=300x250&unviewed_position_start=1&output=vast&impl=s&env=vp&gdfp_req=1&ad_rule=0&vad_type=linear&vpos=preroll&pod=3&ppos=1&lip=true&min_ad_duration=0&max_ad_duration=30000&vrid=6256&cust_params=&url=null&video_doc_id=short_onecue&cmsid=496&kfa=0&tfcd=0&correlator=" + timestamp;
        //settings.advertising.schedule.postroll.tag = window.JW.ads.getVideoURL("vast","postroll");   
    }

    nodo.innerHTML += '<div id="' + nodoId + '"></div>';

    if (autoPlay === true) {
        settings.autostart = true;
    } else {
        settings.autostart = false;
    }

    const player = jwplayer(nodoId).setup(settings);

    //TODO: GOOGLE ANALYTICS---------------------------------------------------------------------------------------------------
    //let eventosParametro = video_id.toString();
    //contenedor.toString();

    player.on("play", function (data) {
        if (data.oldstate === "buffering" && player.getPosition() === 0 && dataLayer){
            dataLayer.push( {'event':'videoPlay', 'videoName':titulo, 'videoTags':arrayTags });
        }
    });

    //player.on("complete", function () {
    //    ga("send", "event", "Video-Nativo", "complete", eventosParametro, { 'dimension10': contenedor });
    //});
    //-------------------------------------------------------------------------------------------------------------------


    //PLAYLIST-----------------------------------------------------------------------------------------------------------
    if (multimedioJWKey) {
        /* Dar formato a la playlist */
        player.on("ready",
            function() {
                let html = "";
                const playlist = player.getPlaylist();
                //console.log(playlist.length);
                //if (playlist.length > 1) {
                if(playlist.length > 1)
                {
                    for (let index = 0; index < playlist.length; index++) {
                        html += "<a href='javascript:void(0)' onclick='javascript:playVideoPlayList(\"" + nodoId + "\", " + index + ")'>";
                        html += playlist[index].title;
                        html += "</a>";
                    }    
                
                    const elemDiv = document.createElement("div");
                    elemDiv.setAttribute("class", "playlist-generico");
                    elemDiv.setAttribute("id", "PlayList-" + video_id);
                    document.getElementById("videoContainerVideo-" + video_id).appendChild(elemDiv);

                    document.getElementById("PlayList-" + video_id).innerHTML = html;
                }
                //}
            });
    }
    if (dataLayer) {
        dataLayer.push( {'event':'videoDisplay', 'videoName':titulo, 'videoTags':arrayTags });
    }
    
    //-------------------------------------------------------------------------------------------------------------------
    //  ga('send', 'event', 'Video-Nativo', 'Embed', eventosParametro, { 'dimension10': contenedor });
    return nodo;
    
   
}

//function areAdsShowed(settings, showAds) {
//    if (showAds != undefined && showAds == 0)
//    {
//        settings.advertising = undefined;
//    }
//    else
//    {
//        settings.advertising.schedule.myAds.tag = ads.getVideoURL("vast", "preroll");
//        settings.advertising.schedule.postroll.tag = ads.getVideoURL("vast","postroll");   
//    }

//    return settings;
//}

function playVideoPlayList (nodoId, index) {
    const player = jwplayer(nodoId);
    player.playlistItem(index);
}
window.playVideoPlayList = playVideoPlayList;


// WEBPACK FOOTER //
// ./Statics/scripts/common/jwplayer/jwplayerRender.js